import React, { useEffect } from "react";
import NavBar from "./NavBar";
import { Container } from "@mui/material";
import SidebarLayout from "./sidebar";
import { useSnackbar } from "../../contexts/SnackbarContext";
import { setSnackbarRef } from "../../utils/snackbarUtils";

export default function Layout(props) {
  const { data, themeMode, isMobile } = props;
  const snackbar = useSnackbar();

  // Set up the legacy snackbarUtils reference for backward compatibility
  useEffect(() => {
    setSnackbarRef(snackbar);
  }, [snackbar]);

  return (
    <>
      <NavBar
        handleThemeChange={props.handleThemeChange}
        data={data}
        themeMode={themeMode}
        handleCollapsed={props.handleCollapsed}
        isMobile={isMobile}
      />
      <div style={{ display: "flex", height: "100%", minHeight: "100vh" }}>
        {
          //if mobile, set sidebar to null
          isMobile ? null : <SidebarLayout collapsed={props.collapsed} />
        }
        <Container
          maxWidth="false"
          //set gutters to 1
          sx={{ pl: 1, pr: 1, pt: 1, pb: 1 }}
          disableGutters={true}
        >
          {props.children}
        </Container>
      </div>
    </>
  );
}
